import { put, takeLatest, all } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import TdsTcsActions, { tdsTcsActionTypes } from '@Actions/configurations/tdsTcsActions';
import TdsTcsServices from '@Services/configurations/tdsTcsServices';

/**
 *
 * @param {*} action
 */
function* _createTdsTcs(action) {
  try {
    yield put(TdsTcsActions.createTdsTcsLoading(true));
    const { payload } = action;
    const newGst = yield TdsTcsServices.createTdsTcs(payload);
    if (newGst.success) {
      yield put(TrackerActions.trackAction(tdsTcsActionTypes.CREATE_TDS_TCS.SUCCESS, {
        request: action?.payload,
        response: newGst,
      }));
      notification.open({
        type: 'success',
        message: 'Tax created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: newGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TdsTcsActions.createTdsTcsLoading(false));
  } catch (error) {
    yield put(TdsTcsActions.createTdsTcsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tdsTcsActionTypes.CREATE_TDS_TCS.ERROR, {
      request: action,
      error,
    }));
  }
}

/**
 *
 */
function* createTdsTcs() {
  yield takeLatest(tdsTcsActionTypes.CREATE_TDS_TCS.REQUEST, _createTdsTcs);
}

/**
 *
 * @param {*} action
 */
function* _getTdsTcs(action) {
  try {
    yield put(TdsTcsActions.getTdsTcsLoading(true));
    const tdsTcs = yield TdsTcsServices.getTdsTcs(action?.page, action?.limit);
    yield put(TdsTcsActions.getTdsTcsSuccess(tdsTcs));
    yield put(TdsTcsActions.getTdsTcsLoading(false));
  } catch (error) {
    yield put(TdsTcsActions.getTdsTcsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tdsTcsActionTypes.GET_TDS_TCS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getTdsTcs() {
  yield takeLatest(tdsTcsActionTypes.GET_TDS_TCS.REQUEST, _getTdsTcs);
}

/**
 *
 * @param {*} action
 */
function* _getDefaultTdsTcs(action) {
  try {
    yield put(TdsTcsActions.getDefaultTdsTcsLoading(true));
    const defaultTdsTcs = yield TdsTcsServices.getDefaultTdsTcs(action?.tdsTcsName);
    yield put(TdsTcsActions.getDefaultTdsTcsSuccess(defaultTdsTcs));
    yield put(TdsTcsActions.getDefaultTdsTcsLoading(false));
  } catch (error) {
    yield put(TdsTcsActions.getDefaultTdsTcsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* getDefaultTdsTcs() {
  yield takeLatest(tdsTcsActionTypes.GET_DEFAULT_TDS_TCS.REQUEST, _getDefaultTdsTcs);
}

/**
 *
 * @param {*} action
 */
function* _updateTdsTcs(action) {
  try {
    yield put(TdsTcsActions.updateTdsTcsLoading(true));
    const updatedGst = yield TdsTcsServices.updateTdsTcs(action.payload);
    if (updatedGst.success) {
      yield put(TrackerActions.trackAction(tdsTcsActionTypes.UPDATE_TDS_TCS.SUCCESS, {
        request: action?.payload,
        response: updatedGst,
      }));
      notification.open({
        type: 'success',
        message: 'Tax updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: updatedGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TdsTcsActions.updateTdsTcsLoading(false));
  } catch (error) {
    yield put(TdsTcsActions.updateTdsTcsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tdsTcsActionTypes.UPDATE_TDS_TCS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* updateTdsTcs() {
  yield takeLatest(tdsTcsActionTypes.UPDATE_TDS_TCS.REQUEST, _updateTdsTcs);
}

/**
 *
 * @param {*} action
 */
function* _deleteTdsTcs(action) {
  try {
    yield put(TdsTcsActions.deleteTdsTcsLoading(true));
    const deletedGst = yield TdsTcsServices.deleteTdsTcs(action.payload);
    if (deletedGst.success) {
      notification.open({
        type: 'success',
        message: 'Tax deleted successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedGst.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(TdsTcsActions.deleteTdsTcsLoading(false));
  } catch (error) {
    yield put(TdsTcsActions.deleteTdsTcsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(tdsTcsActionTypes.DELETE_TDS_TCS.ERROR, {
      request: action,
      error,
    }));
  }
}
/**
 *
 */
function* deleteTdsTcs() {
  yield takeLatest(tdsTcsActionTypes.DELETE_TDS_TCS.REQUEST, _deleteTdsTcs);
}

/**
 *
 */
export default function* tdsTcsSaga() {
  yield all([createTdsTcs(), getTdsTcs(), getDefaultTdsTcs(), updateTdsTcs(), deleteTdsTcs()]);
}
